export const elevation = {
  base: 0,
  dropdown: 10,
  sticky: 20,
  fixed: 30,
  backdrop: 40,
  modal: 50,
  drawer: 60,
  notification: 70,
  tooltip: 80,
  override: 90
}